"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Gift = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Gift_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.722 4.176c-.175.32-.406.598-.68.824h1.708c.69 0 1.25.56 1.25 1.25V9a1 1 0 0 1-1 1v4.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5V10a1 1 0 0 1-1-1V6.25C0 5.56.56 5 1.25 5h1.707a2.822 2.822 0 0 1-.679-.824C1.252 2.294 2.631 0 4.775 0c1.303 0 2.447.887 2.763 2.15L8 4l.462-1.85A2.849 2.849 0 0 1 11.225 0c2.144 0 3.524 2.294 2.497 4.176Zm-4.91.7 2.596-.235a1.824 1.824 0 0 0 1.436-.944C13.502 2.491 12.62 1 11.225 1c-.847 0-1.589.578-1.793 1.393l-.62 2.484ZM8.5 6v3H15V6.25a.25.25 0 0 0-.25-.25H8.5ZM1.25 6H7.5v3H1V6.25A.25.25 0 0 1 1.25 6Zm6.25 4H2v4.5a.5.5 0 0 0 .5.5h5v-5Zm1 5h5a.5.5 0 0 0 .5-.5V10H8.5v5ZM4.592 4.64l2.596.237-.62-2.484A1.849 1.849 0 0 0 4.775 1C3.38 1 2.498 2.491 3.155 3.697c.292.535.831.889 1.437.944Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Gift_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Gift;
exports["default"] = _default;